//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchBar from '@/components/common_searchBar'
import SlidePanel from "@/components/common_slidePanel.vue";
import PageBtns from "@/components/common_pageBtns.vue";
import FlexUserList from "@/components/common_flexUserList";
export default {
  components: { SearchBar, PageBtns, SlidePanel, FlexUserList },
  data() {
    return {
      searchConfig: {
        placeholder: '手机号/会员编号/会员名称'
      },
      btnConfig: {
        list: [ {text:'返回', type: 'primary', action: () => this.$router.go(-1)} ],
      },
      sliderConfig: {
        isShow: false,
        formConfig: {list:[
          { type: 'input', title: '手机号码', placeholder: '请输入手机号码', no_arrow: true },
          { type: 'input', title: '会员名称', placeholder: '请输入会员名称', no_arrow: true },
          { type: 'input', title: '宝宝名称', placeholder: '请输入宝宝名称', no_arrow: true },
        ]},
      },
      listConfig: {
        pageIndex: 1,
        pageSize: 6,
        pageCount: 1,
      },
      userList:[
        {topL:'1.[会员营销抽奖单]白金', topR:'收入：428', 
          bottomL: '结余：428', bottomR: '2019-06-30 00:12:11',
          link: '/mGms/Member/Detail'
        }
      ],
    };
  },


  created () {
    this.getUserList(
      this.listConfig.pageIndex, this.listConfig.pageSize
    )
  },
  computed: {},
  methods: {
    getUserList (pageIndex, pageSize) {
      this.$msg.loading()
      this.$http({
        url: this.$api.MemberReferenceList,
        method: 'post',
        data: { PageIndex: pageIndex, PageSize: pageSize }
      }).then(res => {
        this.$msg.hideLoading()
        if (res.data.state == 1) {
          this.userList = res.data.data.list.map((item,index) => {
            return { 
              topL: index+1+'.'+item.Name, topR: item.CurrentPoints+'分',
              bottomL: item.Mobile, bottomR: item.CreateOn, avatar: item.HeadImgUrl,
              link: `http://ysl.entfly.com/mSms/Member/Detail?openId=${item.OpenId}`
            }
          })
        }
      })
    }
  }
};
